import { render, staticRenderFns } from "./customJiuCheck.vue?vue&type=template&id=00524aa1&scoped=true&"
import script from "./customJiuCheck.vue?vue&type=script&lang=js&"
export * from "./customJiuCheck.vue?vue&type=script&lang=js&"
import style0 from "./customJiuCheck.vue?vue&type=style&index=0&id=00524aa1&lang=scss&scoped=true&"
import style1 from "./customJiuCheck.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00524aa1",
  null
  
)

export default component.exports